import { ExternalLink } from 'lucide-react';
import { getLearningCenterUrl, type LearningCenterArticle } from '../constants/learning-center';

interface LearnMoreLinkProps {
  article: LearningCenterArticle;
  /** Override the default "Learn more" label */
  label?: string;
  className?: string;
}

/**
 * Contextual link to a Learning Center article.
 * Opens in a new tab with proper security attributes.
 */
export function LearnMoreLink({
  article,
  label = 'Learn more',
  className = '',
}: LearnMoreLinkProps) {
  return (
    <a
      href={getLearningCenterUrl(article)}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-1 text-sm text-[#A66B32] hover:text-[#3A2718] transition-colors ${className}`}
    >
      {label}
      <ExternalLink className="h-3 w-3" />
    </a>
  );
}
